import { render, staticRenderFns } from "./WelfarePopup.vue?vue&type=template&id=1face9de&scoped=true&"
import script from "./WelfarePopup.vue?vue&type=script&lang=js&"
export * from "./WelfarePopup.vue?vue&type=script&lang=js&"
import style0 from "./WelfarePopup.vue?vue&type=style&index=0&id=1face9de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1face9de",
  null
  
)

export default component.exports